export type ColorName =
    | "Gray"
    | "Red"
    | "Orange"
    | "Yellow"
    | "Amber"
    | "Green"
    | "Emerald"
    | "Cyan"
    | "Zinc"
    | "Blue"
    | "Lime"
    | "Sky"
    | "Indigo"
    | "Purple"
    | "Teal"
    | "Sky"
    | "Blue"
    | "Purple"
    | "Pink"
    | "Rose";

export const colorNames: ColorName[] = [
    "Gray",
    "Red",
    "Orange",
    "Yellow",
    "Amber",
    "Green",
    "Emerald",
    "Lime",
    "Teal",
    "Cyan",
    "Zinc",
    "Blue",
    "Lime",
    "Sky",
    "Indigo",
    "Purple",
    "Pink",
    "Rose",
];

export const statusColors = {
    gray: { name: "Gray", className: "bg-gray-100 text-gray-700", darkerClassName: "bg-gray-300" },
    red: { name: "Red", className: "bg-red-100 text-red-700", darkerClassName: "bg-red-300" },
    orange: { name: "Orange", className: "bg-orange-100 text-orange-700", darkerClassName: "bg-orange-300" },
    amber: { name: "Amber", className: "bg-amber-100 text-amber-700", darkerClassName: "bg-amber-300" },
    green: { name: "Green", className: "bg-green-100 text-green-700", darkerClassName: "bg-green-300" },
    emerald: { name: "Emerald", className: "bg-emerald-100 text-emerald-700", darkerClassName: "bg-emerald-300" },
    teal: { name: "Teal", className: "bg-teal-100 text-teal-700", darkerClassName: "bg-teal-300" },
    cyan: { name: "Cyan", className: "bg-cyan-100 text-cyan-700", darkerClassName: "bg-cyan-300" },
    zinc: { name: "Zinc", className: "bg-zinc-100 text-zinc-700", darkerClassName: "bg-zinc-300" },
    blue: { name: "Blue", className: "bg-blue-100 text-blue-700", darkerClassName: "bg-blue-300" },
    lime: { name: "Lime", className: "bg-lime-100 text-lime-700", darkerClassName: "bg-lime-300" },
    sky: { name: "Sky", className: "bg-sky-100 text-sky-700", darkerClassName: "bg-sky-300" },
    indigo: { name: "Indigo", className: "bg-indigo-100 text-indigo-700", darkerClassName: "bg-indigo-300" },
    purple: { name: "Purple", className: "bg-purple-100 text-purple-700", darkerClassName: "bg-purple-300" },
    pink: { name: "Pink", className: "bg-pink-100 text-pink-700", darkerClassName: "bg-pink-300" },
    rose: { name: "Rose", className: "bg-rose-100 text-rose-700", darkerClassName: "bg-rose-300" },
};

export const taskListStyles = {
    Green: {
        background: "bg-green-400",
        backgroundLight: "bg-green-50",
        border: "border-green-600",
        text: "text-green-950",
    },
    Blue: {
        background: "bg-blue-400",
        backgroundLight: "bg-blue-50",
        border: "border-blue-600",
        text: "text-blue-950",
    },
    Sky: {
        background: "bg-sky-400",
        backgroundLight: "bg-sky-50",
        border: "border-sky-600",
        text: "text-sky-950",
    },
    Purple: {
        background: "bg-purple-400",
        backgroundLight: "bg-purple-50",
        border: "border-purple-600",
        text: "text-purple-950",
    },
    Pink: {
        background: "bg-pink-400",
        backgroundLight: "bg-pink-50",
        border: "border-pink-600",
        text: "text-pink-950",
    },
    Yellow: {
        background: "bg-yellow-400",
        backgroundLight: "bg-yellow-50",
        border: "border-yellow-600",
        text: "text-yellow-950",
    },
    Amber: {
        background: "bg-amber-400",
        backgroundLight: "bg-amber-50",
        border: "border-amber-600",
        text: "text-amber-950",
    },
    Lime: {
        background: "bg-lime-400",
        backgroundLight: "bg-lime-50",
        border: "border-lime-600",
        text: "text-lime-950",
    },
    Teal: {
        background: "bg-teal-400",
        backgroundLight: "bg-teal-50",
        border: "border-teal-600",
        text: "text-teal-950",
    },
    Red: {
        background: "bg-red-400",
        backgroundLight: "bg-red-50",
        border: "border-red-600",
        text: "text-red-950",
    },
    Orange: {
        background: "bg-orange-400",
        backgroundLight: "bg-orange-50",
        border: "border-orange-600",
        text: "text-orange-950",
    },
    Gray: {
        background: "bg-gray-400",
        backgroundLight: "bg-gray-50",
        border: "border-gray-600",
        text: "text-gray-950",
    },
} as const satisfies Record<
    ColorName,
    {
        background: string;
        backgroundLight: string;
        border: string;
        text: string;
    }
>;
